import { LockMark } from "./Logo";
import { useLang } from "../../i18n";

const Row = ({ hidden, items }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {items.map((t) => (
      <span key={t} className="flex items-center">
        <span className="font-display whitespace-nowrap px-6 text-2xl font-extrabold uppercase tracking-tight text-[#2D2D2D] sm:px-10 sm:text-4xl">
          {t}
        </span>
        <LockMark className="h-7 w-7 sm:h-9 sm:w-9" color="#2D2D2D" />
      </span>
    ))}
  </div>
);

export const Marquee = () => {
  const { t } = useLang();
  return (
  <div data-testid="marquee" className="relative overflow-hidden border-y-2 border-[#2D2D2D] bg-[#F7D048] py-5 sm:py-7">
    <div className="marquee-track flex w-max">
      <Row items={t.marquee} />
      <Row hidden items={t.marquee} />
    </div>
  </div>
  );
};
